import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Terms() {
    return (
        <main className="min-h-screen bg-white">
            <Navbar />
            <div className="pt-32 pb-24 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <h1 className="text-4xl font-bold text-primary mb-8 text-center">Terms of Use</h1>

                <div className="prose prose-blue max-w-none text-text-muted space-y-8">
                    <section>
                        <h2 className="text-2xl font-semibold text-primary mb-4">1. Acceptance of Terms</h2>
                        <p>
                            By accessing or using Ianos, you agree to be bound by these Terms of Use.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-primary mb-4 text-accent">2. 14-Day Pilot Program</h2>
                        <div className="bg-blue-50 border-l-4 border-accent p-6 rounded-r-lg">
                            <p className="font-medium text-primary mb-4">
                                Ianos offers a specialized 14-day Pilot Program to experience the full benefits of our platform.
                            </p>
                            <ul className="list-disc pl-6 space-y-2 text-text-muted">
                                <li>The pilot access is valid for exactly 14 days from the date of registration.</li>
                                <li>After the 14-day period, trial access will automatically terminate.</li>
                                <li>Data collected during the pilot may be deleted upon termination of trial unless an enterprise agreement is established.</li>
                            </ul>
                        </div>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-primary mb-4">3. Continued Use and Sales</h2>
                        <p>
                            If you wish to continue using Ianos after the 14-day pilot program expires, you must establish a commercial agreement with our sales team.
                        </p>
                        <p className="mt-4 font-semibold">
                            To request a full license or enterprise access, please contact us:
                        </p>
                        <ul className="mt-2 list-none space-y-1">
                            <li><strong>Email:</strong> <a href="mailto:nicola.sarli@ianos.io" className="text-accent hover:underline">nicola.sarli@ianos.io</a></li>
                            <li><strong>LinkedIn:</strong> <a href="https://www.linkedin.com/company/ianosinc/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">Connect with us on LinkedIn</a></li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-primary mb-4">4. User Responsibilities</h2>
                        <p>
                            You are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer. You agree to accept responsibility for all activities that occur under your account.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-primary mb-4">5. Intellectual Property</h2>
                        <p>
                            The service and its original content, features, and functionality are and will remain the exclusive property of Ianos and its licensors.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-primary mb-4">6. Limitation of Liability</h2>
                        <p>
                            In no event shall Ianos be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.
                        </p>
                    </section>
                </div>
            </div>
            <Footer />
        </main>
    );
}
